import moment from 'moment';
import StaffEmploymentService from "@/service/StaffEmploymentService";
import JobsService from "@/service/JobsService";
import StaffService from "@/service/StaffService";
import SourceOfAppService from "@/service/SourceOfAppService";
import EmployTypeService from "@/service/EmployTypeService";
import UserService from "@/service/UserService"
import DatePicker from "vue2-datepicker";
import StoreGetter from "@/constants/StoreGetter";
import SweetAlertService from "@/service/SweetAlertService";
import { StaffEmployment } from "@/model/StaffEmployment";
import { StaffEmployHistory } from "@/model/StaffEmployHistory";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import employmentValidationObj from "./S070200-EmploymentValidation.js";
import Settings from '../../../constants/Settings.js';
import ShiftTypeService from "@/service/ShiftTypeService";
var employmentValidation = new employmentValidationObj();
export default {
  name: "employment",
  props: [
    "staffModel", "isEmploymentEditMode", "isEmploymentViewMode"
  ],
  components: {
    DatePicker
  },
  data: () => ({
    t: t,
    dictEnum: dictEnum,
    Settings: Settings,
    staffEmployment: new StaffEmployment(),
    staffEmployHistory: new StaffEmployHistory(),
    jobCodeList: [],
    employTypeList: [],
    CalMethodList:[
      { CalMethod: 'J', desc: 'Date Join' },
      { CalMethod: 'C', desc: 'Date Cut-Off' }
    ],
    staffGradeList: [],
    employStatusList: [],
    departmentList: [],
    teamList: [],
    sourceOfAppsList: [],
    supervisors: [],
    staffSupervisorList: [],
    userList: [],
    isDisabledStartDate: false,
    disabledBefore: new Date(2019, 10, 2),
    shiftList: [],
  }),
  computed: {
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    IsEmploymentValidation() {
      var self = this;
      if (self.staffModel.StaffType == 'C') {
        return true
      }
      return false;
    },
    IsDateJoinValidation() {
      var self = this;
      if (self.staffModel.StaffType == 'C' && (self.staffModel.StaffEmployment.JobCode != '' || self.staffModel.StaffEmployment.SACode != '' || self.staffModel.StaffEmployment.Title != '' || self.staffModel.StaffEmployment.EmpType != '' || self.staffModel.StaffEmployment.StaffGrade != '' || self.staffModel.StaffEmployment.EmpStatus != '' || self.staffModel.StaffEmployment.Dept != '' || self.staffModel.StaffEmployment.TeamCode != '' || self.staffModel.SupervisorID != '')) {
        return true
      }
      return false;
    },
    isEdit() {
      if (this.isEmploymentEditMode) {
        this.getStaffList();
      }
      return this.isEmploymentEditMode;
    },
    teamDataList() {
      let result = [];
      if (this.staffModel.StaffEmployment.Dept) {
        result = this.teamList.filter((x) => x.Dept == this.staffModel.StaffEmployment.Dept)
      }
      return result
    },
    ModClock() {
      const sysParams = this.$store.getters[StoreGetter.sysParams];
      const find =
        sysParams
          .find(x => x.ParamCode == Settings.SysParams.ModCLK);
      if (find) {
        return find.ParamVal.toLowerCase() === "true"
      } else {
        return true
      }
    },
    ModLv() {
      const sysParams = this.$store.getters[StoreGetter.sysParams];
      const find =
        sysParams
          .find(x => x.ParamCode == Settings.SysParams.ModLv);
      if (find) {
        return find.ParamVal.toLowerCase() === "true"
      } else {
        return true
      }
    },
    ModRecu() {
      const sysParams = this.$store.getters[StoreGetter.sysParams];
      const find =
        sysParams
          .find(x => x.ParamCode == Settings.SysParams.ModRecu);
      if (find) {
        return find.ParamVal.toLowerCase() === "true"
      } else {
        return true
      }
    },
    ModPay() {
      const sysParams = this.$store.getters[StoreGetter.sysParams];
      const find =
        sysParams
          .find(x => x.ParamCode == Settings.SysParams.ModPay);
      if (find) {
        return find.ParamVal.toLowerCase() === "true"
      } else {
        return true
      }
    },

    EmpSalary() {
      const salary = this.staffModel.StaffEmployment.Salary;
      return salary > 0 ? salary : null;
    },

    HistorySalary() {
      let salary = this.staffEmployHistory.Salary;
      salary = Number(salary);
      return salary > 0 ? salary : null;
    },
  },
  mounted() {
    employmentValidation.staffEmploymentValidation();
    this.getStaffList();
    this.getAllJob();
    this.getAllEmployType();
    this.getAllStaffGrade();
    this.getAllEmployStatus();
    this.getAllDepartment();
    this.getAllTeam();
    this.getAllSourceOfApps();
    this.getUserList(false);
    this.getShiftList();
  },
  methods: {
    async getStaffList() {
      const obj = {
        staffID: this.staffModel.StaffID
      };
      const response = await StaffService.getAllStaff(obj);
      if (response.data.IsSuccess) {
        const data = response.data.Data;
        this.staffSupervisorList = data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getShiftList() {
      const obj = {};
      const response = await ShiftTypeService.getShiftType(obj);

      if (response.data.IsSuccess) {
        this.shiftList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getAllJob() {
      const obj = {};
      const response = await JobsService.getAllJobs(obj);
      if (response.data.IsSuccess) {
        this.jobCodeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllEmployType() {
      const obj = {};
      const response = await EmployTypeService.getAllEmployTypes(obj);
      if (response.data.IsSuccess) {
        this.employTypeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getUserList(isInResigneUser) {
      const obj = {
        searchText: "",
        sortField: "",
        isInResigneUser: isInResigneUser
      };
      const response = await UserService.getUsers(obj);
      if (response.data.IsSuccess) {
        this.userList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    changeSalary() {
      if (this.staffModel.StaffEmployment.Salary == 0) {
        this.staffModel.StaffEmployment.Salary = null;
      }
    },
    async getAllStaffGrade() {
      const obj = {};
      const response = await StaffEmploymentService.getAllStaffgrades(obj);
      if (response.data.IsSuccess) {
        this.staffGradeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllEmployStatus() {
      const obj = {};
      const response = await StaffEmploymentService.getAllEmployStatus(obj);
      if (response.data.IsSuccess) {
        this.employStatusList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getAllDepartment() {
      const obj = {};
      const response = await StaffEmploymentService.getAllDepartment(obj);
      if (response.data.IsSuccess) {
        this.departmentList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllTeam() {
      const obj = {};
      const response = await StaffEmploymentService.getAllTeams(obj);
      if (response.data.IsSuccess) {
        this.teamList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllSourceOfApps() {
      const obj = {};
      const response = await SourceOfAppService.getAllSourceOfApps(obj);
      if (response.data.IsSuccess) {
        this.sourceOfAppsList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    OnHistoryBtnClick: function () {
      var self = this;
      self.vErrors.clear('EmployHistory');
      self.staffEmployHistory = new StaffEmployHistory();
      $("#StaffHistoryModel").modal("show");
    },
    OnHistoryAddClick: function () {
      var self = this;
      self.$validator.validateAll("EmployHistory").then(result => {
        if (result) {
          const repeat = self.staffModel.StaffEmployHistoryList.find((x) => moment(x.DateTx).format(Settings.DateTime.yyyymmdd) == moment(self.staffEmployHistory.DateTx).format((Settings.DateTime.yyyymmdd)));
          if (repeat) {
            SweetAlertService.warning("Warn", t.t(dictEnum.MSG_StaffEmployHistoryDateTx))
            return;
          }
          if (self.staffEmployHistory.DateTx != null && self.staffEmployHistory.DateTx != "") {
            self.staffEmployHistory.DateTx = moment(self.staffEmployHistory.DateTx).format(
              Settings.DateTime.yyyymmdd
            );
          }
          self.staffModel.StaffEmployHistoryList.push(self.staffEmployHistory);
          self.OnHistoryClear();
        }
      });
    },
    OnHistoryClear: function () {
      var self = this;
      self.staffEmployHistory = new StaffEmployHistory();
      self.$validator.reset();
      self.vErrors.clear('EmployHistory');
    },
    OnHistorySelect: function (item) {
      var self = this;
      self.staffModel.StaffEmployment.Title = item.Title;
      self.staffModel.StaffEmployment.Salary = item.Salary;
      self.staffModel.StaffEmployment.SinceDate = "";
      self.staffModel.StaffEmployment.SinceDate = moment(item.DateTx).format(Settings.DateTime.yyyymmdd);
      $("#StaffHistoryModel").modal("hide");
    },
    async deleteStaffHistory(index) {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.WARN_Delete)}`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        this.staffModel.StaffEmployHistoryList = this.staffModel.StaffEmployHistoryList.filter((x, i) => i != index)
      }
    },
    hideHistroyModal() {
      $("#StaffHistoryModel").modal("hide");
    },
    OnJobCodeBtnClick: function () {
      $("#jobCodeModel").modal("show");
    },
    OnJobCodeSelect: function (model) {
      var self = this;
      self.staffModel.StaffEmployment.JobCode = model.JobCode;
      $("#jobCodeModel").modal("hide");
    },
    saveTerminate: function () {
      var self = this;
      self.staffModel.StaffEmployment.EmpStatus = "R";
      $("#terminateModel").modal("hide");
    },
    openTerminatePopup: function () {
      $("#terminateModel").modal("show");
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProfile/S070200-Employment.js